'use client';

import { useTranslations } from 'next-intl';
import { useRedirectTry } from '@/app/[locale]/_components/use-redirect-try';
import { HOME_PAGE } from '@/app/constants';
import { cn, reportEvent } from '@/app/utils';

interface CreateButtonProps {
  variant?: 'fixed' | 'mobile' | 'md';
  className?: string;
}

export const CreateButton = ({ variant = 'fixed', className }: CreateButtonProps) => {
  const handleClickLogin = useRedirectTry();
  const t = useTranslations('blog.slug.createButton');
  const handleClick = () => {
    reportEvent('blog_create', {
      element_name: `blog - create - ${variant}`,
    });
    handleClickLogin(HOME_PAGE, 'blog - create');
  };

  if (variant === 'mobile') {
    return (
      <div onClick={handleClick} className={cn('text-center font-semibold text-black text-md leading-7', className)}>
        {t('button')}
      </div>
    );
  }

  if (variant === 'md') {
    return (
      <div
        onClick={handleClick}
        className={cn(
          'mt-[19px] flex h-[2.1875rem] w-[9.0625rem] cursor-pointer items-center justify-center rounded-lg bg-[linear-gradient(90deg,_#E0DDFF_0%,_#94D8FF_100%)] text-center font-semibold text-black text-md text-xs leading-7',
          className,
        )}
      >
        {t('button')}
      </div>
    );
  }

  return (
    <div
      onClick={handleClick}
      className={cn(
        'flex h-12 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[linear-gradient(90deg,_#E0DDFF_0%,_#94D8FF_100%)] px-5 py-0 text-center font-semibold text-black leading-5 transition-opacity hover:opacity-90',
        className,
      )}
    >
      {t('button')}
    </div>
  );
};
